import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';
import userStore from '@/store/modules/userStore';
import searchStore from '@/store/modules/searchStore';

export default createStore({
  modules: {
    userStore,
    searchStore,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        "searchStore",
      ]
    })
  ]
});